import Box from '@mui/material/Box';

// project imports
import Profile from './Profile';

// ==============================|| HEADER - CONTENT ||============================== //

export default function HeaderContent() {
  return (
    <Box sx={{ ml: 'auto', display: 'flex', alignItems: 'center' }}>
      <Profile />
    </Box>
  );
}
